import React from 'react'
import {Row, Col, Input, Switch, Select, Divider} from 'antd'

const fileFormat = ['.ppt','.pptx','.xls','.xlsx','.doc','.docx','.pdf','.csv','.txt','.jpg','.jpeg','.png','.webm','.flv','.gif','.avi','.mov','.mp4','.m4v','.mpeg','.aac','.mp3','.m4a','.ogg','.wav']

export default function PropertyContent(props) {
    let {activeField, handleAliasName, handleAliasHelpText, setSwitch, handleFileFormat, handleOptions} = props
    return(
        <React.Fragment>
            <Row gutter={16}>
                <Col span={12}>
                    <label style={{color:'#8697A8'}}>
                        Alias
                    </label>
                    <Input size='large' className='mt-10 custom-input' allowClear value={activeField.alias_name} onChange={handleAliasName} />
                </Col>
                <Col span={12}>
                    <label style={{color:'#8697A8'}}>
                        Help text
                    </label>
                    <Input size='large' className='mt-10 custom-input' allowClear value={activeField.alias_help_text} onChange={handleAliasHelpText} />
                </Col>
            </Row>
            
            <Row style={{marginTop:'30px'}}>
                <Col span={4}>
                    <label style={{color:'#44566C'}}>
                        Multi Entry
                    </label>
                </Col>
                <Col span={20}>
                    <Switch
                        checkedChildren     = 'Yes'
                        unCheckedChildren   = 'No'
                        checked             = {activeField.multi_entry}
                        onChange            = {e=>setSwitch(e, 'multi_entry')}
                    />
                </Col>
            </Row>
            <Row style={{marginTop:'30px'}}>
                <Col span={4}>
                    <label style={{color:'#44566C'}}>
                        Mandatory
                    </label>
                </Col>
                <Col span={20}>
                    <Switch
                        checkedChildren     = 'Yes'
                        unCheckedChildren   = 'No'
                        checked             = {activeField.mandatory}
                        onChange            = {e=>setSwitch(e, 'mandatory')}
                    />
                </Col>
            </Row>
            {/* <Row style={{marginTop:'30px'}}>
                <Col span={4}>
                    <label style={{color:'#44566C'}}>
                        Read Only
                    </label>
                </Col>
                <Col span={20}>
                    <Switch
                        checkedChildren     = 'Yes'
                        unCheckedChildren   = 'No'
                        checked             = {activeField.read_only}
                        onChange            = {e=>setSwitch(e, 'read_only')}
                    />
                </Col>
            </Row> */}
            {/* <Row style={{marginTop:'30px'}}>
                <Col span={4}>
                    <label style={{color:'#44566C'}}>
                        Computed Field
                    </label>
                </Col>
                <Col span={4}>
                    <Switch
                        checkedChildren     = 'Yes'
                        unCheckedChildren   = 'No'
                        checked             = {activeField.computed_field}
                        onChange            = {e=>setSwitch(e, 'computed_field')}
                    />
                </Col>
                <Col span={16}>
                    {
                        activeField.computed_field &&
                            <Input 
                                size='large' 
                                className='custom-input' 
                                allowClear 
                                placeholder='Enter formula' 
                                addonBefore={
                                    <svg width="21" height="19" viewBox="0 0 21 19" fill="none">
                                        <path d="M19.9567 12.6423C19.7488 12.4149 19.482 12.2949 19.1856 12.2949C18.9429 12.2949 18.3479 12.3781 18.0586 13.1485C17.9857 13.3422 17.9648 13.4454 17.8664 13.4349C17.6999 13.4185 17.0516 12.7318 16.8397 11.7233L16.3138 9.28574C16.7293 8.61814 17.1565 8.10288 17.5827 7.75342C17.8116 7.56808 18.0731 7.46995 18.3896 7.45293C19.1981 7.39829 19.4922 7.29743 19.6908 7.15895C20.0186 6.92464 20.1987 6.58569 20.1987 6.2045C20.1987 5.86913 20.0707 5.5701 19.8279 5.33979C19.5935 5.11726 19.2809 4.99979 18.9251 4.99979C18.4021 4.99979 17.8149 5.23977 17.1294 5.73317C16.7247 6.02484 16.2955 6.44889 15.8323 7.01731C15.6816 6.45982 15.5528 6.20009 15.457 6.0448C15.1612 5.56085 14.6806 5.56086 14.5225 5.56086L14.3502 5.56359L9.46674 5.6779L9.74158 4.52089C9.91705 3.76587 10.1474 3.16845 10.4252 2.74523C10.5604 2.5393 10.7672 2.29386 10.9842 2.29386C11.0662 2.29386 11.2283 2.30709 11.5314 2.3695C12.3744 2.55022 12.6895 2.57103 12.8535 2.57103C13.2154 2.57103 13.5337 2.45104 13.7747 2.22409C14.0239 1.98895 14.1555 1.68131 14.1555 1.33458C14.1555 1.0635 14.0656 0.671388 13.6373 0.342313C13.3415 0.115155 12.9357 0 12.4314 0C11.6753 0 10.874 0.239766 10.0493 0.712364C9.23088 1.18139 8.55785 1.82966 8.04927 2.63953C7.6032 3.34958 7.21667 4.34668 6.87211 5.6779H4.71995L4.24569 7.53362H6.40421L4.76402 14.0722C4.42433 15.4262 4.17555 15.7592 4.10753 15.8292C3.9221 16.0192 3.53961 16.0591 3.25141 16.0591C2.89476 16.0591 2.5146 16.0337 2.1179 15.9832C1.84538 15.9502 1.63792 15.9341 1.48408 15.9341C1.08611 15.9341 0.758707 16.0366 0.511407 16.2383C0.235712 16.463 0.0839844 16.7876 0.0839844 17.1526C0.0839844 17.4378 0.177225 17.848 0.622025 18.1813C0.925904 18.4082 1.34019 18.5234 1.85386 18.5234C3.13994 18.5234 4.33851 18.0167 5.41671 17.0177C6.46503 16.0461 7.23299 14.6194 7.69962 12.774L8.9963 7.53425L13.4189 7.60864L13.8944 9.63436L12.9253 11.0524C12.7507 11.3064 12.4907 11.6199 12.1502 11.9856C11.9722 12.1789 11.8539 12.2852 11.7855 12.3405C11.5066 12.0026 11.1902 11.8311 10.8463 11.8311C10.5231 11.8311 10.2296 11.9625 9.99821 12.2102C9.77867 12.4447 9.66275 12.7385 9.66275 13.0588C9.66275 13.4433 9.82868 13.7856 10.1425 14.0483C10.4301 14.2891 10.7855 14.4114 11.198 14.4114C11.7096 14.4114 12.233 14.2179 12.7543 13.8363C13.1894 13.5171 13.7497 12.8852 14.4653 11.9053C14.9251 13.2166 15.5774 14.0596 15.888 14.4116C16.3782 14.9672 17.1699 15.2984 18.0057 15.2984C18.7151 15.2984 19.1169 15.0038 19.4712 14.7434L19.5026 14.7205C20.1226 14.2658 20.2528 13.7654 20.2528 13.4248C20.2523 13.1233 20.15 12.853 19.9567 12.6423Z" fill="#44566C"/>
                                    </svg>
                                } 
                            />
                    }
                </Col>
            </Row> */}
            {
                (activeField && activeField.dataType === 'dropdown') &&
                    <Row className='mt-20 pt-10'>
                        <label style={{color:'#44566C'}}>Options</label>
                        <Select
                            getPopupContainer={(e)=>e.parentNode}
                            mode            = 'tags'
                            className       = 'custom-select fw mt-10'
                            size            = 'large'
                            onChange        = {handleOptions}
                            value           = {activeField.options}
                            placeholder     = 'Add options to this field'
                            allowClear                            
                            dropdownRender  = {menu => (
                                <div>
                                    {menu}
                                    <Divider style={{ margin: '4px 0' }} />
                                    <div style={{ padding: '8px', cursor: 'pointer' }}>
                                       Press enter to add options
                                    </div>
                                </div>
                            )}
                        >
                            {activeField.options.map(type=>(
                                <Select.Option key={type}>{type}</Select.Option>
                            ))}
                        </Select>
                    </Row>
            }
            {
                (activeField && activeField.dataType === 'file') &&
                    <Row className='mt-20 pt-10'>
                        <label style={{color:'#44566C'}}>Supported File Format</label>
                        <Select
                            getPopupContainer={(e)=>e.parentNode}
                            mode            = 'multiple'
                            className       = 'custom-select fw mt-10'
                            size            = 'large'
                            onChange        = {handleFileFormat}
                            value           = {activeField.options}
                            placeholder     = 'All will be selected by default'
                            allowClear
                            filterOption    = {(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }                            
                        >
                            {fileFormat && fileFormat.map(type=>(
                                <Select.Option key={type}>{type}</Select.Option>
                            ))}
                        </Select>
                    </Row>
            }
        </React.Fragment>
    )
}
